import { Spin } from 'antd';
import { ENavigationPath } from 'constants/path';
import { useEffect } from 'react';
import { shouldUseCentralizedRedirectUri } from 'services/msal/configs';

const AuthCallback = () => {
  useEffect(() => {
    if (!shouldUseCentralizedRedirectUri) {
      return;
    }

    const handleCallback = () => {
      try {
        // Get the hash portion of the URL (everything after #)
        const hash = window.location.hash.substring(1);

        // Parse the URL parameters
        const params = new URLSearchParams(hash);

        // Get the state parameter and decode it
        const stateParam = params.get('state');
        if (!stateParam) {
          console.error('No state parameter found in callback URL');
          return;
        }

        // The state parameter contains two parts separated by '|'
        const [, customState] = stateParam.split('|');

        if (!customState) {
          console.error('No custom state found in state parameter');
          return;
        }

        // Parse the JSON string that contains the original redirect URI
        const decodedState = decodeURIComponent(customState);
        const { originalRedirectOrigin } = JSON.parse(decodedState);

        if (!originalRedirectOrigin) {
          console.error('No originalRedirectOrigin found in custom state');
          return;
        }

        // Get the whitelist from env and split into array
        const whitelistedDomains =
          process.env.REACT_APP_WHITELIST_REDIRECT_DOMAINS?.split(',') || [];
        // Parse the redirect URL to get its domain
        const redirectDomain = new URL(originalRedirectOrigin).host;

        // Check if the redirect domain is in the whitelist
        const isValid = whitelistedDomains.some((whitelistEntry) => {
          // Remove any whitespace
          whitelistEntry = whitelistEntry.trim();

          if (whitelistEntry.startsWith('*.')) {
            // Handle wildcard domain
            const wildcardDomain = whitelistEntry.slice(2); // Remove '*.'
            return (
              redirectDomain === wildcardDomain ||
              redirectDomain.endsWith('.' + wildcardDomain)
            );
          } else {
            // Exact domain match
            return redirectDomain === whitelistEntry;
          }
        });

        if (!isValid) {
          console.log(
            'Invalid redirect domain:',
            redirectDomain,
            whitelistedDomains
          );
          return;
        }

        // Construct the new URL with the original redirect URI and the same hash parameters
        const newUrl = `${originalRedirectOrigin}${ENavigationPath.AUTH_CALLBACK}#${hash}`;

        // Redirect to the original URL with all parameters
        window.location.replace(newUrl);
      } catch (error) {
        console.error('Error processing auth callback:', error);
      }
    };

    handleCallback();
  }, []);

  return <Spin className="flex justify-center items-center h-screen" />;
};

export default AuthCallback;
